import React from "react";

import { COLORS } from "@tSurya/theme/design.mgbw";

const MGBWCloseIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M11 10L18.625 2.375C18.9062 2.09375 18.9062 1.65625 18.625 1.375C18.3438 1.09375 17.9062 1.09375 17.625 1.375L10 9L2.375 1.375C2.09375 1.09375 1.65625 1.09375 1.375 1.375C1.09375 1.65625 1.09375 2.09375 1.375 2.375L9 10L1.375 17.625C1.09375 17.9062 1.09375 18.3438 1.375 18.625C1.5 18.75 1.6875 18.8438 1.875 18.8438C2.0625 18.8438 2.25 18.7812 2.375 18.625L10 11L17.625 18.625C17.75 18.75 17.9375 18.8438 18.125 18.8438C18.3125 18.8438 18.5 18.7812 18.625 18.625C18.9062 18.3438 18.9062 17.9062 18.625 17.625L11 10Z" fill={COLORS.primary.base} />
        </svg>
    );
};

export default React.memo(MGBWCloseIcon);

export const MGBWCloseIconSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8.80002 7.9999L14.9 1.8999C15.125 1.6749 15.125 1.3249 14.9 1.0999C14.675 0.874902 14.325 0.874902 14.1 1.0999L8.00002 7.1999L1.90002 1.0999C1.67502 0.874902 1.32502 0.874902 1.10002 1.0999C0.875024 1.3249 0.875024 1.6749 1.10002 1.8999L7.20002 7.9999L1.10002 14.0999C0.875024 14.3249 0.875024 14.6749 1.10002 14.8999C1.20002 14.9999 1.35002 15.0749 1.50002 15.0749C1.65002 15.0749 1.80002 15.0249 1.90002 14.8999L8.00002 8.7999L14.1 14.8999C14.2 14.9999 14.35 15.0749 14.5 15.0749C14.65 15.0749 14.8 15.0249 14.9 14.8999C15.125 14.6749 15.125 14.3249 14.9 14.0999L8.80002 7.9999Z" fill={COLORS.primary.base} />
        </svg>
    );
};
